import { switchHandler } from './switch';
import { dropdownHandler } from './dropdown';
import { inputHandler } from './input';
import { textareaHandler } from './textarea';
import { isJsonString } from './utils';

const fieldValidationCondition = (item) => {

  if (item.hasAttribute('disabled')) return true;

  if (item.tagName === 'SELECT') {
    const parent = item.parentElement;
    const isRequired = parent.getAttribute('required') === 'true';
    const hasError = parent.querySelector('.dropdown_selected')?.classList.contains('input_error');

    if (isRequired) return item?.value?.length > 0 && !hasError;

    return true;
  }

  const isRequired = item.getAttribute('required') === 'true';
  const hasError = item.classList.contains('input_error');

  if (!isRequired && item.type === 'email') return !hasError;

  if (isRequired) return item.value?.length > 0 && !hasError;

  return true;
};

const onFormSubmit = async(e) => {

  e.preventDefault();
  const form = e.target;

  if (!form) return;

  const formFields = Array.from(form.querySelectorAll('input, select, textarea'));
  const labels = Array.from(form.querySelectorAll('label'));

  const fields = [];

  let receiverEmailAddress = form.getAttribute('data-receiver-email-address');

  let isValid = true;

  for (let i = 0; i < formFields.length; i++) {

    if (formFields[i].name === '__RequestVerificationToken') continue;

    const isFieldValid = fieldValidationCondition(formFields[i]);
    if (!isFieldValid) {
      isValid = false;
      break;
    }

    const labelElement = labels.find((lb) => lb.getAttribute('for') === formFields[i]?.id);
    const label = formFields[i]?.type === 'checkbox' ? labelElement?.firstElementChild?.textContent : labelElement?.textContent;
    const sanitizedLabel = label?.replace('(optional)', '')?.trim();

    let value = formFields[i]?.value;

    if (formFields[i].tagName === 'SELECT' && isJsonString(formFields[i]?.value)) {
      const parseValue = JSON.parse(formFields[i]?.value);
      value = parseValue?.value;
      receiverEmailAddress = parseValue?.receiverEmailAddress;
    }

    const fieldItem = {
      label: sanitizedLabel ?? '',
      value,
      required: formFields[i].getAttribute('required') === 'true',
      FieldType: formFields[i].tagName === 'SELECT' ? 'select' : formFields[i]?.type
    };

    fields.push(fieldItem);
  }

  if (isValid) {
    const parent = e.target.parentElement;

    const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
    const token = tokenElement.value;

    const apiUrl = form.getAttribute('data-api-url');
    const senderEmailAddress = form.getAttribute('data-sender-email-address');
    const subject = form.getAttribute('data-form-subject');
    const formKey = form.getAttribute('data-form-key');
    const recaptchaPublicKey = form.getAttribute('data-recaptcha-public-key');

     window.grecaptcha.ready(async function () {
         try {
             const recaptchaToken = await window.grecaptcha.execute(recaptchaPublicKey, { action: 'submit' });

             const requestBody = {
                 formKey,
                 senderEmailAddress,
                 receiverEmailAddress,
                 subject,
                 fields,
                 recaptchaToken
             };

             const res = await fetch(apiUrl, {
                 method: 'POST',
                 headers: {
                     'Content-Type': 'application/json',
                     'RequestVerificationToken': token
                 },
                 body: JSON.stringify(requestBody)
             });

             const html = await res.text();
             if (html) parent.innerHTML = html;

         } catch (error) {
             console.log(error);
             const errorHtml = await error.text();

             if (errorHtml) parent.innerHTML = errorHtml;
         }
       });
  }
};

const checkIfFormIsValid = (submitButton, fields) => {

  if (!fields) return;

  let isValid = true;

  for (let i = 0; i < fields.length; i++) {

    if (fields[i].name === '__RequestVerificationToken') continue;

    const isFieldValid = fieldValidationCondition(fields[i]);
    if (!isFieldValid) {
      isValid = false;
      break;
    }
  }

  if (isValid) {
    return submitButton.removeAttribute('disabled');
  }
  return submitButton.setAttribute('disabled', '');
};

const onFormLoad = () => {
  const forms = document.querySelectorAll('[data-form]');

  if (!forms) return;

  Array.from(forms)?.forEach((form) => {
    const inputs = form.querySelectorAll('[data-input-field]');
    const switches = form.querySelectorAll('[data-switch]');
    const textareas = form.querySelectorAll('[data-textarea]');
    const dropdowns = form.querySelectorAll('[data-dropdown]');
    const submitButton = form.querySelector('button[type="submit"]');
    const fields = Array.from(form.querySelectorAll('input, select, textarea'));

    inputs?.forEach((input) => inputHandler(input, () => checkIfFormIsValid(submitButton, fields)));
    dropdowns?.forEach((dropdown) => dropdownHandler(dropdown, () => checkIfFormIsValid(submitButton, fields)));
    switches?.forEach((sw) => switchHandler(sw, () => checkIfFormIsValid(submitButton, fields)));
    textareas?.forEach((txtArea) => textareaHandler(txtArea, () => checkIfFormIsValid(submitButton, fields)));

    form.addEventListener('submit', onFormSubmit);
  });

};

export default onFormLoad;

